<template>
  <div class="main-container">
    <div class="tab-box">
      <Tabs v-model="tabsValue" :animated="false">
        <TabPane
          :label="item.label"
          :name="item.name"
          v-for="item in tabs"
          :key="item.name"
        ></TabPane>
      </Tabs>
      <div class="tools-box">
        <Button ghost type="primary" @click="close()">返回</Button>
      </div>
    </div>
    
    <component :is="tabsValue" :id="id" :agentId="agentId"></component>
  </div>
</template>
<script>
import detailBasicInfo from "./components/salesman/detailBasicInfo";
import detailFamilyInfo from "./components/salesman/detailFamilyInfo";
import detailInsureInfo from "./components/salesman/detailInsureInfo";
import detailClaimsRecord from './components/salesman/detailClaimsRecord';
import detailFollowUpRecord from "./components/salesman/detailFollowUpRecord";
import detailAccessDynamic from './components/salesman/detailAccessDynamic';

export default {
  components: {
    detailBasicInfo,
    detailFamilyInfo,
    detailInsureInfo,
    detailFollowUpRecord,
    detailClaimsRecord,
    detailAccessDynamic
  },
  data() {
    return {
      tabsValue: "detailBasicInfo",
      tabs: [
        { label: "基础信息", name: "detailBasicInfo" },
        { label: "家庭信息", name: "detailFamilyInfo" },
        { label: "投保信息", name: "detailInsureInfo" },
        { label: "理赔记录", name: "detailClaimsRecord" },
        { label: "跟进记录", name: "detailFollowUpRecord" },
        { label: "访问动态", name: "detailAccessDynamic" },
      ],
      id:this.$route.query.id,
      agentId:this.$route.query.agentId
    };
  },
  methods: {
    close(){
      const fullPath = this.$route.fullPath;
      window.parent.postMessage({
        removePageTag: fullPath,
        appMessage: true,
      }, "*");
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  /deep/ .ivu-tabs-tab {
    padding-left:0 !important;
    padding-top: 0;
  }
  /deep/ .ivu-tabs-ink-bar {
    width: 64px !important;
  }
  .tab-box {
    position: relative;
    .tools-box {
      position: absolute;
      right: 0;
      top: -7px;
    }
  }
}
</style>